/**
 * ABWIN Scratch Popup — Email Capture
 * ---------------------------------------------------------------
 * 'shopify' submits Shopify's own server-rendered {% form 'customer' %}
 * (see snippets/abwin-scratch-config.liquid) via a hidden iframe target.
 * No Admin API token is involved — this is the same mechanism every
 * native Shopify newsletter block uses, safe to trigger from browser JS.
 * A hand-built fetch() POST to /contact is rejected by Shopify with
 * "Missing CAPTCHA token"; only its own rendered form output is trusted.
 */
(function (global) {
  "use strict";

  const cfg = global.ABWIN_POPUP_CONFIG;

  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function isValidEmail(email) {
    return typeof email === "string" && EMAIL_RE.test(email.trim());
  }

  function buildAttributionMetadata() {
    if (!cfg.email.collectAttribution) return {};
    const params = new URLSearchParams(global.location.search);
    return {
      landingPage: global.location.href,
      utm_source: params.get("utm_source"),
      utm_medium: params.get("utm_medium"),
      utm_campaign: params.get("utm_campaign"),
      popupVersion: cfg.popupVersion,
      discountCode: cfg.discount.code,
      timestamp: new Date().toISOString(),
    };
  }

  function submitMock(email, metadata) {
    return new Promise((resolve) => {
      setTimeout(() => {
        console.log("[abwin-email:mock] would submit ->", { email, metadata });
        resolve({ ok: true, provider: "mock" });
      }, cfg.email.mockDelayMs);
    });
  }

  function submitShopify(email) {
    return new Promise((resolve, reject) => {
      const form = document.getElementById("abwin-scratch-hidden-form");
      const emailInput = document.getElementById("abwin-scratch-hidden-email-input");
      const iframe = document.getElementById("abwin-scratch-hidden-iframe");
      if (!form || !emailInput || !iframe) {
        reject(new Error("shopify_form_missing"));
        return;
      }
      emailInput.value = email;
      const onLoad = () => {
        iframe.removeEventListener("load", onLoad);
        resolve({ ok: true, provider: "shopify" });
      };
      iframe.addEventListener("load", onLoad);
      form.submit();
    });
  }

  function submitKlaviyo() {
    return Promise.reject(
      new Error(
        "submitKlaviyo() is a Phase 2 stub. Needs a Klaviyo public API key " +
          "and confirmation that Klaviyo is back in budget before wiring."
      )
    );
  }

  const PROVIDERS = {
    mock: submitMock,
    shopify: submitShopify,
    klaviyo: submitKlaviyo,
  };

  const AbwinEmail = {
    isValidEmail,

    submit(email) {
      const trimmed = (email || "").trim();
      if (!isValidEmail(trimmed)) {
        return Promise.reject(new Error("invalid_email"));
      }
      const provider = PROVIDERS[cfg.email.provider] || submitMock;
      const metadata = buildAttributionMetadata();
      return provider(trimmed, metadata);
    },
  };

  global.AbwinEmail = AbwinEmail;
})(window);
